import api from "@/utils/http";

/**
 功能：
 time: 2026/1/5 11:06
 **/
export function getBuyerConfig() {
    return api.get('/admin/buyer/getSetConfig')
}

/**
 功能：
 time: 2026/1/5 11:42
 **/
export function getBuyerList(data) {
    return api.post('/admin/buyer/getList', data)
}

/**
 功能：
 time: 2026/1/5 14:50
 **/
export function getBuyerDetail(buyer_id) {
    return api.post('/admin/buyer/getDetail', {buyer_id })
}

/**
 功能：
 time: 2026/1/5 14:52
 **/
export function saveBuyer(data) {
    return api.post('/admin/buyer/eSave', data)
}

/**
 功能：
 time: 2026/1/6 11:30
 **/
export function examineBuyer(data) {
    return api.post('/admin/buyer/examineSave', data)
}

/**
 功能：
 time: 2025/12/25 16:02
 **/
export function getBuyerSelectList(data) {
    return api.post('/admin/buyer/getSearchList',data)
}

/**
 功能：
 time: 2025/12/27 09:15
 **/
export function getBuyerAccount(buyer_id) {
    return api.post('/admin/buyer/getAccount', {buyer_id })
}

/**
 功能：
 time: 2026/3/23 12:38
 **/
export function getBuyerMoney(buyer_id) {
    return api.post('/admin/buyer/getBuyerMoney', {buyer_id })
}

/**
 功能：
 time: 2026/1/6 09:18
 **/
export function deleteBuyer(buyer_id) {
    return api.post('/admin/buyer/del', {buyer_id})
}


